export class CorosiveProtectionModel {
    _id: string;
    id: number;
    name: string;
    description: string;

    constructor(_id = null,
        id = null,
        name = '',
        description = '') {
            this._id = _id;
            this.id = id;
            this.name = name;
            this.description = description;
    }
}
